<template>

<core-modal v-on:close="onClose" :is-empty="!items.length" :nopadding="true">

	<template v-slot:head>

		Manage Views

	</template>

	<template v-slot:default>

		<template v-for="item in items">

			<com-view :key="item.id" :item="item" />

		</template>

        <div class="manage-empty" v-if="!items.length">

            No views created.

        </div>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onCreateClick">Create View</core-button>

	</template>

</core-modal>

</template>

<script>

import comView from './manage/View'

export default {

	props: ['data'],

	components: {
		comView
	},

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	computed: {

		items: function() {

			var items = []

			items = this.$_.sortBy(this.$store.getters['data/views/list'], function(item) {

				return item.name.toLowerCase()

			})

			return items

		}

	},

	methods: {

        onCreateClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'viewsManageCreate',
				manage: true
			})	

        },

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.manage-empty {
    position: absolute;
    left: 0%;
    top: 50%;
    width: 100%;
    font-size: 20px;
    color: #fff;
    opacity: 0.75;
    font-weight: 400;
    text-align: center;
    line-height: 24px;
    padding: 16px;
}

</style>